<div class="container">
  <gymfinder-options-chips
    [selectedChips]="options?.gymTypes"
    (chipsChange)="onGymTypesChanged($event)"
    [allChips]="defaultOptions?.gymTypes"
    [disabledChips]="disabledGymTypes"
    [getTranslation]="getTranslation('gymTypes')"
    [name]="'Gym Types'"
    [editMode]="editMode"></gymfinder-options-chips>

  @if (
    creditsFeatureFlag &&
    !!options?.gymTypes &&
    options?.gymTypes!.includes(GymType.WELLPASS_FR_BE_CREDITS)
  ) {
    <gymfinder-credits
      [creditsConfig]="creditsConfig"
      (creditsConfigChange)="onCreditsConfigChanged($event)"
      [editMode]="editMode"></gymfinder-credits>
  }

  <div class="main-activity">
    <p class="title">Main Activity</p>
    <mat-form-field class="main-activity-list">
      <mat-label>Main Activity</mat-label>
      <mat-select
        [(ngModel)]="mainActivity"
        name="gym.options?.activities[0]?.activity || ''"
        [disabled]="!editMode">
        @for (activity of defaultOptions?.activities; track activity) {
          <mat-option [value]="activity.activity">{{
            getTranslation('activities')(activity.activity)
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <gymfinder-options-checkboxes
    [selectedItems]="convertActivitiesToItems(options?.activities || [])"
    (itemsChange)="onActivitiesChanged($event)"
    [allItems]="convertActivitiesToItems(defaultOptions?.activities || [])"
    [getTranslation]="getTranslation('activities')"
    [name]="'Activities'"
    [editMode]="editMode"></gymfinder-options-checkboxes>

  <gymfinder-options-checkboxes
    [selectedItems]="convertServicesToItems(options?.services || [])"
    (itemsChange)="onServicesChanged($event)"
    [allItems]="convertServicesToItems(defaultOptions?.services || [])"
    [getTranslation]="getTranslation('services')"
    [name]="'Services'"
    [editMode]="editMode"></gymfinder-options-checkboxes>

  <gymfinder-options-chips
    [selectedChips]="options?.gymEquipments"
    (chipsChange)="onOptionsChanged({ field: 'gymEquipments', value: $event })"
    [allChips]="defaultOptions?.gymEquipments"
    [disabledChips]="disabledEquipments"
    [getTranslation]="getTranslation('gymEquipments')"
    [name]="'Gym Equipment'"
    [editMode]="editMode"></gymfinder-options-chips>

  <gymfinder-options-chips
    [selectedChips]="options?.equipmentsToBring"
    (chipsChange)="
      onOptionsChanged({ field: 'equipmentsToBring', value: $event })
    "
    [allChips]="defaultOptions?.equipmentsToBring"
    [getTranslation]="getTranslation('equipmentsToBring')"
    [name]="'Equipment to bring'"
    [editMode]="editMode"></gymfinder-options-chips>

  <gymfinder-options-chips
    [selectedChips]="filterGymInfos(options?.gymInfos, false)"
    (chipsChange)="onGymInfosChanged($event, false)"
    [allChips]="filterGymInfos(defaultOptions?.gymInfos, false)"
    [getTranslation]="getTranslation('gymInfos')"
    [name]="'Gym Information'"
    [editMode]="editMode"></gymfinder-options-chips>

  <gymfinder-options-chips
    [selectedChips]="filterGymInfos(options?.gymInfos, true)"
    (chipsChange)="onGymInfosChanged($event, true)"
    [allChips]="[CASHBACK_PARTNER]"
    [getTranslation]="getTranslation('gymInfos')"
    [name]="'Cashback partner (enable this gym option if this gym is a cashback partner)'"
    [editMode]="editMode"></gymfinder-options-chips>

  @if (defaultOptions?.geniusFeatures?.length ?? -1 > 0) {
    <gymfinder-options-chips
      [selectedChips]="options?.geniusFeatures"
      (chipsChange)="
        onOptionsChanged({ field: 'geniusFeatures', value: $event })
      "
      [allChips]="defaultOptions?.geniusFeatures"
      [getTranslation]="getTranslation('geniusFeatures')"
      [name]="'Genius Feature Configuration (Internal)'"
      [editMode]="editMode">
    </gymfinder-options-chips>
  }
</div>
